import { render } from "./userDashboard.vue?vue&type=template&id=1f4feef0"
import script from "./userDashboard.vue?vue&type=script&lang=js"
export * from "./userDashboard.vue?vue&type=script&lang=js"

import "./userDashboard.vue?vue&type=style&index=0&id=1f4feef0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__